import { createAction } from "@reduxjs/toolkit";

/**
 * Shared logout actions for Redux state management
 * These actions are handled by multiple slices to reset their state
 */
export const userNormalLogout = createAction("auth/userNormalLogout");
export const supportLogout = createAction("auth/supportLogout");
